import styled from "styled-components";


export const AlertContainerStyled = styled.div`
    position: fixed;
    top: 0;
    z-index: 100000000;
    width: 100%;

    &.slide-out {
        opacity: 0;
        transform: translateX(100%);
        transition: opacity 0.5s ease, transform 0.5s ease;
    }
    .line{
        position: absolute;
        top: 0;
        width: 100%;
        height: 3px;
        background: ${({ variant }) =>
                variant === "success"
                        ? "rgb(75,181,67)"
                        : variant === "info"
                                ? "rgb(67,182,253)"
                                : "rgb(220,20,60)"};
       
    }
    .slide-in {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 0.5s ease, transform 0.5s ease;
    }
    .alert{
        position: absolute;
        right: 0;
        top: 1rem;
        display: flex;
        flex-direction: column;
        width: 80%;
        min-height: 100px;
        border-radius: 1.25rem;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);

        background: ${({ variant }) =>
                variant === "success"
                        ? "rgb(75,181,67)"
                        : variant === "info"
                                ? "rgb(67,182,253)"
                                : "rgb(220,20,60)"};
        .icon {
            font-size: 1.5rem;
            position: relative;
            top: 4px;
            left: 4px;
            color: #fff;
        }

        .closeBtn {
            cursor: pointer !important;
            position: absolute;
            top: 6px;
            right: 10px;
            background: transparent;
            border: none;
            color: #fff;
            font-size: 1.3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px;
            line-height: 1;
            transition: opacity .2s ease;
            z-index: 2;
            pointer-events: auto;
            min-width: 32px;
            min-height: 32px;
            border-radius: 8px;
        }
        .closeBtn:hover {
            opacity: 0.75;
        }

        .errorText {
            text-align: center;
            font-size:1.3rem;
            color: #fff;
            margin-top: 0.5rem;
        }
        &.slide-in {
            opacity: 1;
            transform: translateX(0);
            transition: opacity 0.5s ease, transform 0.5s ease;
        }

        &.slide-out {
            opacity: 0;
            transform: translateX(100%);
            transition: opacity 0.5s ease, transform 0.5s ease;
        }
        @media only screen and (min-width: 992px) {
            width: 30%;
        }
    }
`;
